import { FormSelectComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/field-select-config.interface';
import { ApplicationsLoaderService } from '@ordersnproducts/modules/multiple-order-online/modules/controllers/loaders/application.loader.service';
import { UpdateValueCommand } from '@ordersnproducts/modules/multiple-order-online/modules/controllers/commands/update-value.provider';
import { createField } from '../create-field.utils';
import { SpecFieldTestIds } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-test-ids.enum';

export const APPLICATION_FIELD_NAME = 'application';

const ApplicationField = createField<FieldSelectConfig>({
  name: APPLICATION_FIELD_NAME,
  type: FormSelectComponent,
  label: 'views.specifications.application',
  dataTId: SpecFieldTestIds.APPLICATION,
  placeholder: 'views.specifications.select_application',
  optionsLoader: ApplicationsLoaderService,
  onChange: [UpdateValueCommand],
});

export default ApplicationField;
